import { Button } from "@kaltura/ds-react-components";
import { Recyclebin24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { BulkActionProps } from "@kaltura/mediaspace-shared-selectable-media-list";
import { useBulkRestore } from "./useBulkRestore";
import { BulkRestoreConfirmationModal } from "./BulkRestoreConfirmationModal";

interface BulkRestoreProps extends BulkActionProps {
    entryIds: string[];
    apiUrl: string;
}

/**
 * Component for bulk restoring entries from the recycle bin
 * @data-endpoint recyclebin-recycle-bin-ds-restore
 */
export const BulkRestore = ({ entryIds, reloadMedia, apiUrl }: BulkRestoreProps) => {
    const { selectedCount, openConfirmation, processing, handleClick, handleRestore, closeConfirmation } =
        useBulkRestore({ entryIds, reloadMedia, apiUrl });

    return (
        <>
            <Button
                variant="borderless"
                color="secondary"
                onClick={handleClick}
                disabled={entryIds.length === 0}
                startIcon={<Recyclebin24Icon />}
            >
                {translate("Restore")}
            </Button>

            <BulkRestoreConfirmationModal
                open={openConfirmation}
                processing={processing}
                selectedCount={selectedCount}
                onClose={closeConfirmation}
                onConfirm={handleRestore}
            />
        </>
    );
};

export default BulkRestore;
